import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import ColumnChooser from '../../../components/ColumnChooser';
import ExcelExportMenu from '../../../components/ExcelExportMenu';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { CALISMA, durumRengi, ilkOtomatikFaturaListIstegi, OTOMATIK_FATURA_SAYFASI, OtomatikFaturaCalismasi, OtomatikFaturaListIstegi, OtomatikFaturaService, tl } from '../../../services/OtomatikFaturaService';
import CalismaDetayModal from './Components/CalismaDetayModal';

const SUREN = [CALISMA.BEKLIYOR, CALISMA.CALISIYOR, CALISMA.GONDERILIYOR];

/**
 * Ayarlar > Otomatik Faturalama > Çalışma Geçmişi (22.10.2026). Her satır bir kuralın bir dönem çalışması; satıra
 * tıklayınca faturalar, kayıt satırları ve işlemler açılır. Süren çalışma varken liste 15 sn'de bir yenilenir.
 */
const OtomatikFaturaGecmis = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const pageName = OTOMATIK_FATURA_SAYFASI
    const sayfaAnahtari = pageName + " > Geçmiş";
    const pageVersion = "1";
    const [data, setData] = useState<{ list: OtomatikFaturaCalismasi[], totalRecordCount: number }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<OtomatikFaturaListIstegi>({ ...ilkOtomatikFaturaListIstegi, kuralId: searchParams.get('kuralId') ?? undefined })
    const [acikCalisma, setAcikCalisma] = useState<string | undefined>(undefined);

    const getColumns = () => {
        var str = localStorage.getItem(sayfaAnahtari + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Tarih', name: 'planlananZamanStr', order: 0, isVisible: true },
            { title: 'Modül', name: 'modulAdi', order: 0, isVisible: true },
            { title: 'Kural', name: 'kuralAdi', order: 0, isVisible: true },
            { title: 'Dönem', name: 'donemAdi', order: 0, isVisible: true },
            { title: 'Tetikleyen', name: 'tetikleyenAdi', order: 0, isVisible: true },
            { title: 'Durum', name: 'durumAdi', order: 0, isVisible: true },
            { title: 'Fatura', name: 'faturaSayisi', order: 0, isVisible: true },
            { title: 'Hata', name: 'hataliSayisi', order: 0, isVisible: true },
            { title: 'Toplam (₺)', name: 'toplam', order: 0, isVisible: true },
            { title: 'Onaylayan', name: 'onaylayanAdi', order: 0, isVisible: true },
            { title: 'Mesaj', name: 'mesaj', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    // Süren çalışma varken sessizce yenilenir (yükleniyor göstergesi açılmaz).
    useEffect(() => {
        if (!data.list.some(x => SUREN.includes(x.durum)))
            return;

        const zamanlayici = setInterval(() => getData(undefined, true), 15000);
        return () => clearInterval(zamanlayici);
    }, [data, filter])

    const lastRequestNo = useRef(0);

    const getData = async (_filter: OtomatikFaturaListIstegi | undefined = undefined, sessiz: boolean = false) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            if (!sessiz)
                dispatch(storeActivityIndicator(true))

            var response = await OtomatikFaturaService.calismaListesi(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            if (!sessiz)
                toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current && !sessiz)
                dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await OtomatikFaturaService.calismaExport(buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.otomatikFaturaCalismasiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const sortableColumns = ['planlananZamanStr', 'modulAdi', 'kuralAdi', 'donemAdi', 'durumAdi', 'faturaSayisi', 'hataliSayisi', 'toplam'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        planlananZamanStr: { type: 'date' },
        modulAdi: { type: 'text' },
        kuralAdi: { type: 'text' },
        donemAdi: { type: 'text' },
        tetikleyenAdi: { type: 'text' },
        durumAdi: { type: 'text' },
        faturaSayisi: { type: 'number' },
        hataliSayisi: { type: 'number' },
        toplam: { type: 'number' },
        onaylayanAdi: { type: 'text' },
        mesaj: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: OtomatikFaturaCalismasi, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger: any = item2[column];

        if (column == 'durumAdi')
            deger = <span className={`badge badge-light-${durumRengi(item.durum)}`}>{item.durumAdi}</span>;
        else if (column == 'toplam')
            deger = tl(item.toplam);
        else if (column == 'hataliSayisi')
            deger = item.hataliSayisi > 0 ? <span className="text-danger fw-bold">{item.hataliSayisi}</span> : 0;
        else if (column == 'onaylayanAdi')
            deger = item.onaylayanAdi ?? (item.durum == CALISMA.ONAY_BEKLIYOR ? <span className="text-warning">{item.onaylayiciAdi} bekleniyor</span> : (item.onayGerekli ? '' : 'Onaysız'));

        return <td className={className} style={{ cursor: 'pointer' }} onClick={() => setAcikCalisma(item.otomatikFaturaCalismasiId)}>{deger}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <div style={{ flex: 1 }}></div>

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={sayfaAnahtari} pageVersion={pageVersion} setColumns={setColumns} />

                <ExcelExportMenu pageName={pageName} selectedCount={0} onExport={excelExport} />

                {
                    filter.kuralId && (
                        <div className='m-0'>
                            <a onClick={() => getData({ ...filter, kuralId: undefined, currentPage: 1, skip: 0 })} className='btn btn-sm fw-bold btn-light'>Tüm kurallar</a>
                        </div>
                    )
                }

                <div className='m-0'>
                    <a onClick={() => navigate('/otomatikfatura/list')} className='btn btn-sm fw-bold btn-light-primary'>Kurallar</a>
                </div>
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName + ' > ',
                isActive: false,
                path: ''
            }]}>Çalışma Geçmişi</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.otomatikFaturaCalismasiId}>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={0}
                    />
                </KTCard>
            </Content>

            <CalismaDetayModal calismaId={acikCalisma} onClose={() => setAcikCalisma(undefined)} onDegisti={() => getData(undefined, true)} />
        </React.Fragment>
    )
}

export default OtomatikFaturaGecmis;
